// @flow
import type { FluxStandardAction } from 'flux-standard-action';
import { API_CALL } from './apiMiddleware';
import type { ExtractReturn } from '../types';

export const LOGIN = 'gdpr/auth/LOGIN';
export const LOGIN_PENDING = 'gdpr/auth/LOGIN_PENDING';

export const LOGOUT = 'gdpr/auth/LOGOUT';
export const SESSION = 'gdpr/auth/SESSION';

const login: FluxStandardAction<> = (email) => ({
  type: LOGIN,
  payload: [email],
  meta: {
    [API_CALL]: 'requestMagicLink'
  }
});
const logout: FluxStandardAction<> = () => ({
  type: LOGOUT
});
const getSession: FluxStandardAction<> = (type, token) => ({
  type: SESSION,
  payload: [type, token],
  meta: {
    [API_CALL]: 'getSessionToken'
  }
});

export type Actions =
  | ExtractReturn<typeof login>
  | ExtractReturn<typeof getSession>;

export type State = {
  +session?: {},
  +hasFetched?: boolean,
  +isFetching?: boolean,
  +error?: boolean
};

export default function reducer(
  state: State = {},
  action: Actions | FluxStandardAction<>
): State {
  switch (action.type) {
    case LOGIN:
      return action.error
        ? {
            ...state,
            error: action.error,
            payload: action.payload,
            hasFetched: true,
            isFetching: false
          }
        : {
            ...state,
            hasFetched: true,
            isFetching: false
          };
    case LOGOUT:
      return {};
    case LOGIN_PENDING:
      return {
        ...state,
        error: false,
        hasFetched: false,
        isFetching: true
      };
    case SESSION:
      return action.error
        ? {
            ...state,
            error: action.error,
            payload: action.payload
          }
        : {
            ...state,
            session: action.payload,
            hasFetched: true
          };
    default:
      return state;
  }
}

export const actions = {
  login,
  logout,
  getSession
};
